import SubaruLogo from '@components/bits/icons/SubaruLogo';
import SimpleBlockContent from '@components/bits/SimpleBlockContent';
import React, { FunctionComponent } from 'react';

import FooterColumn from './FooterColumn';
import FooterGoBackColumn from './FooterGoBackColumn';
import FooterMiscColumn from './FooterMiscColumn';
import styles from './index.module.scss';

type Props = {
  footerNavigationC1: { header: string; elements };
  footerNavigationC2: { header: string; elements };
  socielMediaList;
  copyright;
  misc;
  disclamer;
};

const Footer: FunctionComponent<Props> = ({
  footerNavigationC1,
  footerNavigationC2,
  copyright,
  misc,
  disclamer,
}) => {
  return (
    <footer className={styles.root}>
      <div className={styles['_wrapper']}>
        <header className={styles['_header']}>
          <div className={styles['_logo']}>
            <SubaruLogo color="white" />
          </div>
          <FooterGoBackColumn />
        </header>
        <div className={styles['_top']}>
          <FooterColumn header={footerNavigationC1.header} elements={footerNavigationC1.elements} />
          <FooterColumn header={footerNavigationC2.header} elements={footerNavigationC2.elements} />
        </div>
        <div className={styles['_bottom']}>
          <div className={styles['_disclamer']}>
            <SimpleBlockContent data={disclamer} />
          </div>
          <FooterMiscColumn misc={misc} copyright={copyright} />
        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
